import { render, staticRenderFns } from "./LikesModule.vue?vue&type=template&id=5ed40a72&scoped=true"
import script from "./LikesModule.vue?vue&type=script&lang=js"
export * from "./LikesModule.vue?vue&type=script&lang=js"
import style0 from "./LikesModule.vue?vue&type=style&index=0&id=5ed40a72&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed40a72",
  null
  
)

export default component.exports